// Hero.js
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaCalendarAlt, FaHeart, FaBabyCarriage } from "react-icons/fa";
import HeroSlideshow from "./HeroSlideshow";
import { EVENT_VIDEOS, scrollTargetFor } from "../../config/eventVideos";
import "./Hero.css";

const HERO_ICONS = {
    heart: FaHeart,
    baby: FaBabyCarriage
};

const Hero = () => {
    const { t } = useTranslation();

    // The headline, icon and date follow whichever slide is showing, so the
    // hero reads as that event rather than always announcing the wedding.
    const [activeIndex, setActiveIndex] = useState(0);

    // Stable identity: HeroSlideshow lists this in an effect's deps, so a new
    // function each render would re-run the effect on every render.
    const handleActiveChange = useCallback(index => setActiveIndex(index), []);

    // One slide per event, built from the same list the video section below
    // renders from — so a slide can never point at an anchor that is not on
    // the page. `scrollTargetFor` falls back when an event has no video yet.
    const slides = EVENT_VIDEOS.map(event => ({
        src: event.image,
        alt: t(event.altKey),
        objectPosition: event.objectPosition,
        targetId: scrollTargetFor(event),
        // Each event names its own call to action; the generic "watch" text is
        // only the fallback for one that does not.
        linkLabel: t(
            event.watchKey || "eventVideos.watch",
            event.watchDefault || "Se øyeblikket"
        )
    }));

    const activeEvent = EVENT_VIDEOS[activeIndex] || EVENT_VIDEOS[0];
    const HeadlineIcon = HERO_ICONS[activeEvent.heroIcon] || FaHeart;

    return (
        <div className="hero-wrapper">
            <HeroSlideshow slides={slides} onActiveChange={handleActiveChange} />

            {/* Keyed on the active event so React remounts the text, which
                re-triggers the fade-in rather than swapping words abruptly
                mid-crossfade. */}
            <div className="hero-content" key={activeEvent.key}>
                <div className="announcement hero-text-in">
                    <h2>
                        <HeadlineIcon className="icon" />{" "}
                        {t(activeEvent.heroHeadlineKey, activeEvent.heroHeadlineDefault)}
                    </h2>
                </div>

                <div className="names hero-text-in" style={{ animationDelay: "120ms" }}>
                    <h1>Tunno &amp; Haubuah</h1>
                </div>

                <div className="date hero-text-in" style={{ animationDelay: "240ms" }}>
                    <h2><FaCalendarAlt className="icon" /> {t(activeEvent.dateKey)}</h2>
                </div>
            </div>
        </div>
    );
};

export default Hero;
